module.exports = __webpack_public_path__ + "img/LinkAja_logo.cf60d1fa.webp";